import React, { Component } from "react";
import { Table, Row, Col, Tooltip, DatePicker, Icon, Button } from "antd";
import axios from "axios";
import "./Pages.css";
import moment from "moment-timezone";
import { maskDate } from "../utils/Masker";
import PessoaFrame from '../components/PessoaFrame';
import numeral from "numeral";
import FiltrosForm from '../components/FiltrosForm';

const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;
const { RangePicker } = DatePicker;


export default class extends Component {
  state = {
    listaRegistros: [],
    pagina: 1,
    limite: 20,
    total: 0,

    vlrVencidas: 0,
    vlrAVencer: 0,

    carregando: false,
    formFiltroVisivel: false,

    filtros: {
      tipoTela: 'CTASREC',
      buscaOrdem: { campo: 'pes_nome', ordem: 'ASC' },
      buscaDataIni: moment(new Date()).subtract(730, 'days').format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date()).format('DD/MM/YYYY'),
      // buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      // buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }

  getListaRegistros = () => {
    this.setState({
      listaRegistros: [], carregando: true, vlrVencidas: 0, vlrAVencer: 0
    });
    const { buscaOrdem, buscaDataIni, buscaDataFim, buscaPessoa } = this.state.filtros;
    const { pagina, limite } = this.state;

    if ((buscaDataIni) && (buscaDataFim)) {

      // console.log('getListaRegistros.buscaOrdem: ', buscaOrdem);

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      this.setState({ carregando: true, vlrVencidas: 0, vlrAVencer: 0 });
      axios
        .get('/vendas/listaCtasReceber', {
          params: {
            page: pagina,
            limite: limite,
            campoOrdem: buscaOrdem.campo,
            tipoOrdem: buscaOrdem.ordem,
            cliente: buscaPessoa.key,
            dataIni,
            dataFim,
            print: 0,
            dispositivo: 'web',
          }
        })
        .then(response => {
          // console.log('getListaRegistros: ', response.data);
          const { data, total, current_page, per_page } = response.data.dados;
          // console.log('getListaRegistros: ', data);
          this.setState({
            listaRegistros: data,
            carregando: false,
            total: total,
            pagina: current_page,
            limite: Number(per_page),

            vlrVencidas: response.data.vencidas,
            vlrAVencer: response.data.aVencer,
          });
        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    }
  };



  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formFiltroVisivel, filtros, total, pagina, limite } = this.state;

    // console.log('ContasAReceberPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Contas À Receber</h2>
        <hr />
        <br />
        <Row>
          <div className="pageFiltro" style={{ height: 70, marginTop: -20 }}>
            <Row>

              <Col xs={2} style={{ width: 200, marginTop: 8 }}>
                <Button
                  onClick={this.onAbrirFiltroClick}
                  className="pageFiltro-filtrar"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <FiltrosForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />


              <Col xs={24} sm={10} style={{ marginTop: -5 }}>
                <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: "#e50000", color: "white", borderRadius: 3 }} >
                  <Row><span style={{ fontWeight: "bold" }}>Vencidas</span></Row>
                  <Row><span>{this.renderValor(this.state.vlrVencidas)}</span></Row>
                </Col>
                <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: "#7cd4a5", color: "white", borderRadius: 3 }} >
                  <Row><span style={{ fontWeight: "bold" }}>À Vencer</span></Row>
                  <Row><span>{this.renderValor(this.state.vlrAVencer)}</span></Row>
                </Col>
                <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: "black", color: "white", borderRadius: 3 }} >
                  <Row><span style={{ fontWeight: "bold" }}>Total</span></Row>
                  <Row><span>{this.renderValor(this.state.vlrVencidas + this.state.vlrAVencer)}</span></Row>
                </Col>
              </Col>
            </Row>
          </div>
        </Row>


        <Row style={{ marginTop: -30 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.cr_pessoa + '_' + registro.cr_documento)}
          >
            <Column
              key="pes_codigo"
              dataIndex="pes_codigo"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"8%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Nome Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"20%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="cr_vlr_total"
              dataIndex="cr_vlr_total"
              title={this.renderTitulo("Valor")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={"10%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="cr_emissao"
              dataIndex="cr_emissao"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="cr_prorrogacao"
              dataIndex="cr_prorrogacao"
              title={this.renderTitulo("Prorrogação")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="cr_data_venc"
              dataIndex="cr_data_venc"
              title={this.renderTitulo("Vencimento")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="cr_documento"
              dataIndex="cr_documento"
              title={this.renderTitulo("Documento")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"20%"}
              align="left"
              className="listaCadastro"
            />
          </Table>

        </Row>

      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ContasAReceberPage.js